<script setup lang="ts">
import { defineProps, PropType } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { useCustomRouter } from "@/utils/router";
import { OrderType } from "@/types/order/Order";

defineProps({
  orderType: {
    type: String as PropType<OrderType>,
    required: true
  },
  existsLimitedOrder: {
    type: Boolean,
    required: true
  },
  existsIndividualOrder: {
    type: Boolean,
    required: true
  }
});

const { pushIgnoreError } = useCustomRouter();

const emit = defineEmits(["update:orderType"]);

const changeToPublic = async () => {
  await pushIgnoreError({
    name: "Search"
  });
};

const changeToLimited = async () => {
  await pushIgnoreError({
    name: "SearchLimitedOrders"
  });
};

const changeToIndividual = async () => {
  await pushIgnoreError({
    name: "SearchIndividualOfferOrders"
  });
};
</script>

<template>
  <div class="tab-container">
    <div
      class="tab-content"
      :class="{ 'tab-content-active': orderType === 'public' }"
      @click="changeToPublic"
    >
      一般
    </div>
    <div
      class="tab-content"
      :class="{ 'tab-content-active': orderType === 'limited' }"
      @click="changeToLimited"
    >
      <FeatherIcon icon="key" size="16" class="mr-2" />
      限定
      <div class="exists-orders-badge" v-if="existsLimitedOrder" />
    </div>
    <div
      class="tab-content"
      :class="{ 'tab-content-active': orderType === 'individual' }"
      @click="changeToIndividual"
    >
      <FeatherIcon icon="award" size="16" class="mr-2" />
      指名
      <div class="exists-orders-badge" v-if="existsIndividualOrder" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-container {
  display: flex;
  width: 100vw;
  height: 40px;
  padding: 0 16px;
}

.tab-content {
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  border-bottom: 1px solid $gray-300;

  &-active {
    color: $primary;
    border-bottom: 1px solid $primary;
  }
}

.exists-orders-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  background-color: $red;
  border-radius: 50%;
}

.svg-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
</style>
